import React, { FC, useEffect, useState } from 'react';
import Colors from '../resources/Colors';
import { Appbar, Divider, Menu, Button, Icon, Badge } from 'react-native-paper';
import GlobalStyles from "../resources/Styles";
import { ScrollView, RefreshControl, Platform, SafeAreaView, StatusBar, StyleSheet, Text, TouchableOpacity, View } from 'react-native';
import { useAppDispatch, useAppSelector } from '../store/hooks';
import { logout } from '../controller/authController';
import moment from "moment";
import { ACTION_NOTIFICATION, ICON_NOTIFICATION, NOTIFICATION, STATUS_NOTIFICATION } from "../utils/status";
import { setNotificationsSendCount, setNotifications } from "../store/slices/notificationSlice";
import Alerts from './Alerts';

const MORE_ICON = Platform.OS === 'ios' ? 'dots-horizontal' : 'dots-vertical';

let Courier;
if (Platform.OS !== 'web') {
  Courier = require('@trycourier/courier-react-native');
} else {
  Courier = () => null; // Componente vacío o implementación web
}

type MyProps = IRoute & {
  showBackIcon?: boolean,
  backAction?: Function,
  toggleMenu?: Function
};

const AdjuvoAppBar: FC<MyProps> = (props) => {
  const { navigation, showBackIcon = false, backAction = null, toggleMenu = () => { } } = props;

  const auth = useAppSelector(state => state.auth);
  const notificationStore = useAppSelector(state => state.notification);
  const dispatch = useAppDispatch();

  const [menuVisibleLeft, setMenuVisibleLeft] = useState(true)
  const [menuVisible, setMenuVisible] = useState(false)
  const [notificationsVisible, setNotificationsVisible] = useState(false)
  const [notificationsReady, setNotificationsReady] = useState(false)
  const [allNotifications, setAllNotifications] = useState<any[]>([]); //useState(null)
  const [seenAll, setSeenAll] = useState(false)

  const [sendNotifications, setSendNotifications] = useState<any[] | null>(null)
  const [seenNotifications, setSeenNotifications] = useState<any[] | null>(null)

  const [refreshing, setRefreshing] = useState(false);


  /** AGENCY DIALOGS**/
  const [showInterviewOptions, setShowInterviewOptions] = useState(false)
  const [showLinkMeet, setShowLinkMeet] = useState(false)

  const openMenu = () => {
    setMenuVisible(true)
  };

  const closeMenu = () => {
    setMenuVisible(false)
  };
  const closeNotifications = () => setNotificationsVisible(false);

  useEffect(() => {

    if (Platform.OS === "ios") {
      // Handle pushes
      const pushListener = Courier.shared.addPushNotificationListener({
        onPushNotificationDelivered: (push: any) => {
    
        },
        onPushNotificationClicked: (push: any) => {
        }
      });
      return () => {
        pushListener.remove();
      }
    }

  }, [allNotifications, notificationsReady]);

  useEffect(() => {
    if (notificationStore.notifications) {
      let newNotifications: INotification[] = [];
      newNotifications = newNotifications.concat(notificationStore.notifications);
      setAllNotifications(newNotifications)

      showNotifications(newNotifications);
    }
  }, [notificationStore.notifications])

  const goToProfile = () => {
    setMenuVisible(false)
    navigation.navigate('ProfileScreen', {});
  }

  const showNotifications = (newNotifications: any) => {
    let listSends = newNotifications.filter((x: any) => x.id_notification_status === STATUS_NOTIFICATION.SEND).slice(0, 10);
    let listSeen = newNotifications.filter((x: any) => x.id_notification_status === STATUS_NOTIFICATION.SEEN).slice(0, 10);

    setSendNotifications(listSends ?? [])
    setSeenNotifications(listSeen ?? [])
  }

  const showAllNotifications = () => {
    let listSends = allNotifications && allNotifications.filter(x => x.id_notification_status === STATUS_NOTIFICATION.SEND);
    let listSeen = allNotifications && allNotifications.filter(x => x.id_notification_status === STATUS_NOTIFICATION.SEEN);

    setSendNotifications(listSends ?? [])
    setSeenNotifications(listSeen ?? [])

    setSeenAll(true)
  }

  const getNotificationIcon = (item: INotification) => {
    return item.id_notification_type === NOTIFICATION.JOB ? ICON_NOTIFICATION[NOTIFICATION.JOB]
      : item.id_notification_type === NOTIFICATION.CANDIDATE ? ICON_NOTIFICATION[NOTIFICATION.CANDIDATE]
        : item.id_notification_type === NOTIFICATION.INTERVIEW ? ICON_NOTIFICATION[NOTIFICATION.INTERVIEW]
          : ICON_NOTIFICATION[NOTIFICATION.RESULT]
  }

  const actionNotification = (item: INotification): void => {
    let notification = isJson(item.additional_information) ? JSON.parse(item.additional_information) : null;

    if (item.id_notification_status === STATUS_NOTIFICATION.SEND) {
      const itemCpy = Object.assign({}, item)
      itemCpy.id_notification_status = STATUS_NOTIFICATION.SEEN;
     // dispatch(updateNotificationAction(itemCpy, auth.userInfo.id_user))

      dispatch(setNotifications([]))
      setSendNotifications(null)

      if (seenAll) {
        showAllNotifications()
      } else {
        showNotifications(allNotifications);
      }
    }

    switch (item.id_action) {
      case ACTION_NOTIFICATION.CREATE_JOB:
        navigation.navigate('JobDetailsScreen', { jobItem: notification.job });
        break;
      case ACTION_NOTIFICATION.CLOSE_JOB:
        navigation.navigate('Jobs');
        break;
      case ACTION_NOTIFICATION.SUBMITTAL:
      case ACTION_NOTIFICATION.CANDIDATE_REJECT:
        break;
      case ACTION_NOTIFICATION.NEXT_INTERVIEW_REQUEST:
        break;
      case ACTION_NOTIFICATION.INTERVIEW_REQUEST:
      case ACTION_NOTIFICATION.RESCHEDULE_AGENCY:
        console.log("INTERVIEW RE SCHEDULE:")
        console.log(item)
        break;
      case ACTION_NOTIFICATION.RESCHEDULE_CLIENT:
      case ACTION_NOTIFICATION.NEW_INTERVIEW:
      case ACTION_NOTIFICATION.CANCEL_INTERVIEW:
        break;
      case ACTION_NOTIFICATION.DECLINED:
      case ACTION_NOTIFICATION.REVIEW_FEEDBACK:
        navigation.navigate('AgencyInterviewReviewScreen', {
          jobId: notification.jobId,
          candidateObject: notification.candidate,
          interviewObject: notification.interviewObject,
        });
        break;
      case ACTION_NOTIFICATION.ACCEPT_OFFER:
      case ACTION_NOTIFICATION.NEW_OFFER:
      case ACTION_NOTIFICATION.APPROVE_OFFER:
        break;
      //default:
      //return null;
    }

    closeNotifications()
  }

  const isJson = (str: string) => {
    try {
      JSON.parse(str);
    } catch (e) {
      return false;
    }
    return true;
  }

  const reloadScreen = () => {
    setNotificationsReady(false)

    setTimeout(() => {
      setRefreshing(false);
    }, 1500);
  }

  const onCopyLink = () => {
    
  }

  const onShowMeetAlert = () => {
    setShowLinkMeet(!showLinkMeet);
  }

  return (
    <SafeAreaView style={{ backgroundColor: Colors.bgBlue, width: '100%', maxWidth: '100%' }}>
      <StatusBar barStyle="light-content" />
      <Appbar
        style={{
          marginTop: 0,
          paddingTop: 0,
          backgroundColor: Colors.bgBlue,
          height: 50,
        }}>
        {showBackIcon && (
          <Appbar.Action
            icon={'chevron-left'}
            size={30}
            onPress={() => {
              if (backAction) {
                backAction();
              }
              navigation.goBack();
            }}
            color={Colors.bgWhite}
          />
        )}

          <Appbar.Action
            icon={menuVisibleLeft ? "menu" : "arrow-right"}
            color={Colors.textWhite}
            onPress={() => {
              //toggleMenu();
              navigation.openDrawer();
              //setMenuVisibleLeft(!menuVisibleLeft)
              //navigation.setParams({ hideTabBar: !menuVisibleLeft })
            }} />

        {!showBackIcon && (
          <Appbar.Action icon={'account'} color={Colors.bgWhite} 
          onPress={() => { 
            openMenu(); 
          }}
          />
        )}
        <Appbar.Content
          title={
            <View style={{ width: '100%' }}>
              <Text style={{ color: Colors.textWhite, width: '100%' }}>
                {auth.userInfo ? auth.userInfo.name : ''}
              </Text>
              <Text style={{ color: Colors.textWhite, fontSize: 12 }}>
                {auth.userInfo ? auth.userInfo.email : ''}
              </Text>
            </View>
          }
        />
        {/* <View style={[Platform.OS === "ios" ? styles.bellIOS : styles.bellWeb]}>
          <Appbar.Action
            icon="bell-outline"
            onPress={() => openNotifications()}
            iconColor={Colors.bgWhite}
          />
          {notificationStore.notificationsSendCount > 0 &&
            <Badge style={{ position: 'absolute', right: 10, top: 10 }} size={18}>
              {notificationStore.notificationsSendCount}
            </Badge>
          }
        </View> */}
        {
          Platform.OS === "ios"? (
            <Appbar.Action
              icon={MORE_ICON}
              onPress={() => { openMenu(); }}
              iconColor={Colors.bgWhite}
            />
          ): null
        }
      </Appbar>
      <View style={{ flexDirection: 'row', justifyContent: 'flex-start', alignItems: 'center' }}>
        <Menu
          style={{ width: 150 }}
          visible={menuVisible}
          onDismiss={closeMenu}
          anchor={<Button style={{ width: 10, height: 1 }}>&nbsp;</Button>}
        >
          {/* <Menu.Item onPress={() => goToProfile()} title={
            <View style={{ flex: 0, flexDirection: 'row', alignItems: 'center' }}>
              <Icon size={24} source={'account-circle'} />
              <Text style={{ marginStart: 8 }}>My Profile</Text>
            </View>
          } />
          <Divider /> */}
          <Menu.Item onPress={async () => {
            setMenuVisible(false)
            dispatch(logout(navigation));
          }} title={(
            <View style={{ flex: 0, flexDirection: 'row', alignItems: 'center' }}>
              <Icon size={24} source={'logout'} />
              <Text style={{ marginStart: 8 }}>Logout</Text>
            </View>
          )} />
        </Menu>
      </View>


      <View style={{ flexDirection: 'row', justifyContent: 'flex-end', alignItems: 'center', }}>
        <Menu
          style={{ width: '100%', marginStart: 8, backgroundColor: Colors.bgWhite }}
          visible={notificationsVisible}
          onDismiss={closeNotifications}
          anchor={<Button style={{ width: '100%', height: 1 }}>&nbsp;</Button>}
        >
          <ScrollView scrollEnabled={true}
            refreshControl={<RefreshControl refreshing={refreshing} onRefresh={reloadScreen} />} >

            <View style={[styles.horizontalContent, { width: '100%' }]}>
              <Text style={[styles.title_22_bold, { marginStart: 10, marginBottom: 20, flex: 1 }]}>Notifications</Text>
              <View>
                <Appbar.Action style={{ flex: 1 }}
                  icon={'reload'} color={Colors.bgBlue} onPress={() => {
                    reloadScreen()
                    setRefreshing(true)
                    setSeenAll(true)
                  }} />
              </View>
            </View>

            <View style={{ marginStart: 10, marginBottom: 20 }}>
              <Text style={[styles.label_16_bold, { marginBottom: 5 }]}>New</Text>
              {sendNotifications && sendNotifications.map((notification, index) => (
                <View key={'notification_' + index} style={{ marginStart: 10 }}>
                  <TouchableOpacity style={{ flex: 0, flexDirection: 'row', paddingVertical: 10 }}
                    onPress={() => actionNotification(notification)}>
                    <View style={{ height: 30, padding: 3, backgroundColor: Colors.orangeLight, borderRadius: 15 }}>
                      <Icon size={24} source={getNotificationIcon(notification)} color={Colors.orangeIcon} />
                    </View>
                    <View style={{ flex: 1, marginStart: 8 }}>
                      <Text style={styles.label_13_bold}>{notification.name}</Text>
                      <Text style={[styles.label_13, { color: Colors.eclipse }]}>{notification.description}</Text>
                      <Text
                        style={[styles.label_13, { color: Colors.eclipse }]}>{notification.created_on ? moment(notification.created_on, 'YYYY-MM-DDTHH:mm:ss').format('LL') : "Now"}</Text>
                    </View>
                  </TouchableOpacity>
                  <Divider />
                </View>
              ))}

              {sendNotifications && sendNotifications.length == 0 &&
                <View><Text style={{ color: Colors.grayTextButton }}>Any notifications found</Text></View>
              }
            </View>

            <View style={{ marginStart: 10 }}>
              <Text style={[styles.label_16_bold, { marginBottom: 5 }]}>Earlier</Text>
              {seenNotifications && seenNotifications.map((notification: any, index: any) => (
                <View key={'notification_' + index} style={{ marginStart: 10 }}>
                  <TouchableOpacity style={{ flex: 0, flexDirection: 'row', paddingVertical: 10 }}
                    onPress={() => actionNotification(notification)}>
                    <View style={{ height: 30, padding: 5, backgroundColor: Colors.orangeLight, borderRadius: 15 }}>
                      <Icon size={20} source={getNotificationIcon(notification)} color={Colors.orangeIcon} />
                    </View>
                    <View style={{ flex: 1, marginStart: 8 }}>
                      <Text style={styles.label_13_bold}>{notification.name}</Text>
                      <Text style={[styles.label_13, { color: Colors.eclipse }]}>{notification.description}</Text>
                      <Text
                        style={[styles.label_13, { color: Colors.eclipse }]}>{moment(notification.created_on, 'YYYY-MM-DDTHH:mm:ss').format('LL')}</Text>
                    </View>
                  </TouchableOpacity>
                  <Divider />
                </View>
              ))}

              {/* {seenNotifications && seenNotifications.length == 0 &&
                <View><Text style={{ color: Colors.grayTextButton }}>Any notifications found</Text></View>
              } */}
            </View>

            {/* {canSeeAllButton() && <Button onPress={() => showAllNotifications()}>See All</Button>} */}
          </ScrollView>
        </Menu>
      </View>

      <Alerts />

    </SafeAreaView>
  );
};

const styles = StyleSheet.create({
  bellWeb: { flex: 1, flexDirection: 'row-reverse' },
  bellIOS: { flex: 0, flexDirection: 'row' },
  ...GlobalStyles
});


export default AdjuvoAppBar;
